var _rect, _rect2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcCancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 38,
    viewBox: "0 0 42 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 41,
    height: 37,
    rx: 4.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 41,
    height: 37,
    rx: 4.5,
    stroke: "#BBBBBB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6665 24.3333L20.9998 19L15.6665 24.3333ZM26.3332 13.6666L20.9988 19L26.3332 13.6666ZM20.9988 19L15.6665 13.6666L20.9988 19ZM20.9998 19L26.3332 24.3333L20.9998 19Z",
    fill: "#435869"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6665 24.3333L20.9998 19L26.3332 24.3333M26.3332 13.6666L20.9988 19L15.6665 13.6666",
    stroke: "#435869",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCancel);
export default __webpack_public_path__ + "static/media/ic-cancel.681af01d41f5e25c800b3a72fcdea53d.svg";
export { ForwardRef as ReactComponent };